import React from 'react';

const OrderInfo = ({ order }) => {
  return order ? (
    <React.Fragment>
      <div className="sidebar-info__item">
        <span>Водитель</span>
        <span>{order.orderDrivers}</span>
      </div>
      <div className="sidebar-info__item">
        <span>ТС</span>
        <span>{order.orderVehicle}</span>
      </div>
      <div className="sidebar-info__item">
        <span>Ответств.</span>
        <span>{order.carrier}</span>
      </div>
      <div className="sidebar-info__item">
        <span>Наблюдат.</span>
        <span>{order.observer}</span>
      </div>
      <div className="sidebar-info__item" style={{ marginTop: 16 }}>
        <span>Создал</span>
        <span>{order.creator}</span>
      </div>
    </React.Fragment>
  ) : null;
};

export default OrderInfo;
